<div class="contacts-list-container">
  <div class="contacts-list-header">
    <h2 class="contacts-list-title">{{ title() }}</h2>
    <button mat-button class="add-contact-button" (click)="onAddContact()">
      <mat-icon class="add-icon material-icons-outlined">
        add_circle_outline
      </mat-icon>
      {{ addButtonText() }}
    </button>
  </div>

  <div class="contacts-table-wrapper">
    <table mat-table [dataSource]="contacts()" class="contacts-table">
      <ng-container matColumnDef="contactName">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let contact">
          <span class="contact-name">{{ contact.contactName }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="contactEmail">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let contact">
          {{ contact.contactEmail }}
        </td>
      </ng-container>

      <ng-container matColumnDef="contactType">
        <th mat-header-cell *matHeaderCellDef>Contact Type</th>
        <td mat-cell *matCellDef="let contact">
          <app-chip
            [label]="contact.contactType"
            [variant]="getContactTypeVariant(contact.contactType)"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="contactPhone">
        <th mat-header-cell *matHeaderCellDef>Phone</th>
        <td mat-cell *matCellDef="let contact">
          {{ contact?.contactPhone !== "" ? contact.contactPhone : "—" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let contact; let i = index">
          <div class="actions-cell">
            <button
              mat-icon-button
              class="action-button"
              (click)="onEditContact(contact, i)"
              [matTooltip]="'Edit contact'"
              aria-label="Edit contact"
            >
              <mat-icon class="material-icons">edit</mat-icon>
            </button>
            <span
              [matTooltip]="
                contact.isPrimary
                  ? 'Primary contacts cannot be deleted'
                  : 'Delete contact'
              "
              [matTooltipDisabled]="false"
            >
              <button
                mat-icon-button
                class="action-button"
                [disabled]="contact.isPrimary"
                (click)="onDeleteContact(contact, i)"
                aria-label="Delete contact"
              >
                <mat-icon class="material-icons">delete</mat-icon>
              </button>
            </span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="table-row"
      ></tr>
    </table>
  </div>
</div>
